(function ($) {
  Drupal.behaviors.contentFilterSetV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var that = this;

      that.setup(context);
    },
    setup: function (context) {
      var self = this;

      self.attached = true;
      var $modules = $('.js-content-filter-set--v1', context);

      $modules.each(function () {
        var $module = $(this);
        var $triggerBtn = $('.js-content-filter-cta', $module);
        var $closeBtn = $('.js-content-filter-cta--close', $module);
        var $thisTemplate = $(this);
        var $filterBtn = $();
        var $submitBtn = $('.js-content-filter-set-submit', $thisTemplate);
        var $resetBtn = $('.js-content-filter-set-reset', $thisTemplate);
        var $filterSets = $('.js-content-filter-set__filters', $thisTemplate);
        var $collapsedFilter = $('.js-content-filter-set__title', $thisTemplate);
        var eventWasMissed = $module.hasClass('js-content-secondary-filter-init-fired');
        var $filtersContainer = $('.js-content-filter-set__container', $module);

        $filtersContainer.appendTo('body'); // This moves the element instead of cloning
        $(document).on('contentFilter.filtered', function (event, $results) {
          updateAvailableFilters($results);
        });
        $(document).on('contentFilter.secondaryFilterReset', function () {
          reset();
        });
        $(document).on('contentFilter.initSecondaryFilters', function (event, data) {
          renderFilters(data);
        });
        $(document).on('contentFilter.passSecondaryFiltersIntoUrl', function () {
          return processSecondaryFilters();
        });
        if (eventWasMissed) {
          $module.trigger('contentFilter.secondaryFiltersReady');
        }

        // Function to fetch query parameters into an object.
        function getUrlVars() {
          var queryParamObj = {},
            hash = {};
          var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

          for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            queryParamObj[hash[0]] = hash[1];
          }

          return queryParamObj;
        }

        function processSecondaryFilters() {
          var activeValues = '';
          var generatedURL = '';

          $filterSets.each(function () {
            var $secondaryFilterItem = $(this);
            var filterKey = $secondaryFilterItem.prev().data('filter-title');
            var $selectedItems = $secondaryFilterItem.find(
              '.js-content-filter-set-button',
              $filtersContainer
            );
            var queryVal = [];
            var queryValues = '';

            $selectedItems.each(function () {
              var $selectedItem = $(this);

              if ($selectedItem.hasClass('active')) {
                activeValues = sanitizedSecondaryFilter($(this).text());
                queryVal.push(activeValues);
                queryValues = queryVal.join(',');
                filterKey = sanitizedSecondaryFilter(filterKey).toLowerCase();
              }
            });
            generatedURL = queryValues
              ? (generatedURL += '&' + filterKey + '=' + queryValues)
              : generatedURL;
          });

          return generatedURL;
        }

        function sanitizedSecondaryFilter(str) {
          return str.replace(/ /g, '_').trim();
        }

        function renderFilters(data) {
          var index = 0;
          var queryParams = getUrlVars();

          $filterSets.each(function () {
            var $set = $(this);
            var filterSetData = data[index];
            var secondaryFilters = $set.data('filter-secondary');
            var allSecondaryFilters = [];
            var filterSetWrap = {};

            if (secondaryFilters) {
              if (!allSecondaryFilters[index]) {
                allSecondaryFilters[index] = [];
              }
              secondaryFilters.split(',').forEach(function (filterSecondary) {
                var trimmedFilter = filterSecondary.trim();
                var selector =
                  'js-secondary-filter-' +
                  index +
                  '--' +
                  sanitizedSecondaryFilter(filterSecondary).toLowerCase();

                if (trimmedFilter.length) {
                  allSecondaryFilters[index][trimmedFilter] = selector;
                }
              });
              filterSetData = allSecondaryFilters[index];
            }

            if (filterSetData) {
              filterSetWrap = Object.keys(filterSetData);
              if (!secondaryFilters) {
                filterSetWrap.sort();
              }
              filterSetWrap.forEach(function (key) {
                var $setkey = $set.find('[data-filter =".' + filterSetData[key] + '"]');

                if ($setkey.length === 0) {
                  $set = $set.append(
                    '<li role="button" class="content-filter-set__button js-content-filter-set-button" data-filter=".' +
                      filterSetData[key] +
                      '" tabindex="0">' +
                      key +
                      '</li>'
                  );
                }
                Object.keys(queryParams)
                  .sort()
                  .forEach(function (queryKey) {
                    var decodedQueryKey = decodeURIComponent(queryKey);

                    if (decodedQueryKey !== 'section' && decodedQueryKey !== 'sort') {
                      var paramVal = queryParams[queryKey];
                      var paramValArr = paramVal.replace(/_/g, ' ').split(',');

                      for (var i = 0; i < paramValArr.length; i++) {
                        if (
                          decodedQueryKey.replace(/_/g, ' ') ===
                            $set.prev().data('filter-title').toLowerCase() &&
                          decodeURIComponent(paramValArr[i]) === key
                        ) {
                          $setkey = $set.find('[data-filter =".' + filterSetData[key] + '"]');
                          $setkey.addClass('selected active');
                        }
                      }
                    }
                  });
              });
            }
            index++;
          });

          $filterBtn = $('.js-content-filter-set-button', $filtersContainer);
          $filterBtn.once().on('click keyup', function (event) {
            if (!clickOrEnter(event)) {
              return;
            }
            if ($(this).hasClass('disabled')) {
              return;
            }
            $(this).toggleClass('selected active');
            toggleFilterButtons();
          });
          filter();
        }

        function clickOrEnter(event) {
          return event.type === 'click' || (event.type === 'keyup' && event.keyCode === 13);
        }

        function updateAvailableFilters($results) {
          if ($results && $results.length) {
            $filterBtn.each(function () {
              var selector = $(this).data('filter');

              toggleFilterElement($results.filter(selector).length, $(this));
            });
          } else {
            $filterBtn.removeClass('selected active').addClass('disabled');
          }
          toggleFilterButtons();
        }

        function toggleFilterElement(count, $el) {
          if (count === 0) {
            $el.addClass('disabled').removeClass('active selected');
          } else {
            $el.removeClass('disabled');
          }
        }

        function getFilterClasses() {
          var filterClasses = [];

          $filterBtn.filter('.selected').removeClass('selected');
          $filterBtn.filter('.active').each(function () {
            filterClasses.push($(this).data('filter'));
          });

          return filterClasses.join(',');
        }

        // Grabs the filter selectors and joins them
        function filter() {
          $(document).trigger('contentBlock.secondaryFilter', [getFilterClasses()]);
        }

        function toggleFilterButtons() {
          var filterActive = $filterBtn.filter('.active').length || false;

          if (filterActive) {
            $resetBtn.removeClass('disabled');
          } else {
            $resetBtn.addClass('disabled');
          }
        }

        function clearSelectedFilters() {
          $filterBtn.filter('.selected.active').removeClass('selected active');
        }
        // Reset filters
        function reset() {
          $filterBtn.removeClass('active selected');
          toggleFilterButtons();
        }

        // Close menu
        function close() {
          toggleFiltersContainer(false);
          clearSelectedFilters();
        }

        function toggleFiltersContainer(open) {
          var $filtersInner = $('.js-content-filter-set__container--inner', $filtersContainer);

          $filtersInner.toggleClass('active', open);
          $('html').toggleClass('filters-container-open', open);
          $('body').toggleClass('sticky-header-opened', open);
          if (open) {
            setTimeout(function () {
              $(document).on('click.outsideContentFilters', function (event) {
                var $target = $(event.target);

                if (!$target.closest($filtersContainer).length > 0) {
                  close();
                }
              });
            }, 1);
          } else {
            $(document).off('click.outsideContentFilters');
          }
        }

        $resetBtn.on('click.reset', function () {
          reset();
        });

        // Apply results
        $submitBtn.once().on('click', function (event) {
          var $button = $(this);

          event.preventDefault();
          if ($button.hasClass('button--disabled')) {
            return;
          }
          filter();
          close();
        });

        // Toggle menu
        $triggerBtn.once().on('click', function () {
          toggleFiltersContainer(true);
        });

        $closeBtn.once().on('click', function () {
          close();
        });

        $collapsedFilter.once().on('click keyup', function (event) {
          if (!clickOrEnter(event)) {
            return;
          }
          var $this = $(this);

          if ($this.hasClass('disabled')) {
            return;
          }
          $this
            .toggleClass('opened')
            .next('.js-content-filter-set__filters')
            .toggleClass('collapsed');
        });

        $triggerBtn.keyup(function (event) {
          if (event.keyCode === 13) {
            if ($(this).hasClass('content-filter-cta--close')) {
              close();
            } else {
              $filtersContainer.fadeIn(100);
              $('.content-filter-cta--close', $filtersContainer).focus();
            }
          }
        });

        $(document).keyup(function (event) {
          if (event.keyCode === 27 && $filtersContainer.is(':visible')) {
            close();
          }
        });
      });
    },
    attached: false
  };
})(jQuery);
